import { safeLs } from 'shared/storages';

import type { IKeycloakTokens } from './types';

const KEYCLOAK_TOKENS_KEY = 'keycloakTokens';

export const authStorage = {
  setJwtAuthParams(value: Partial<IKeycloakTokens>): Promise<Partial<IKeycloakTokens>> {
    return safeLs.add<IKeycloakTokens>(KEYCLOAK_TOKENS_KEY, value);
  },
  getJwtAuthParams(): IKeycloakTokens | undefined {
    return safeLs.get(KEYCLOAK_TOKENS_KEY, { parse: true, type: 'sync' });
  },
  clearJwtAuthParams() {
    return safeLs.delete(KEYCLOAK_TOKENS_KEY, { returning: false });
  },
};
